"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceQuery = exports.orderQuery = exports.filterQuery = exports.findConstraints = exports.buildQuery = void 0;
/**
 * A generic function that finds constraints of a specific type and
 * returns them as an array of the generic type provided during the function call.
 * @param constraints - An array of query constraints.
 * @param type - The type of query constraint to find.
 * @returns An array of query constraints of the specified type.
 */
var findConstraints = function (constraints, type) {
    return constraints.filter(function (constraint) { return constraint.type === type; });
};
exports.findConstraints = findConstraints;
/**
 * A function that builds a filter query from a list of filter constraints.
 * @param constraints - An array of filter constraints.
 * @returns A filter query string.
 * @example
 * const constraints = [
 *  {
 *    type: 'filter',
 *    field: 'name',
 *    operator: 'match',
 *    value: 'John',
 *  },
 *  {
 *    type: 'filter',
 *    field: 'age',
 *    operator: '>=',
 *    value: 18,
 *  },
 * ]
 * const filterQueryString = filterQuery(constraints)
 * console.log(filterQueryString)
 * => `name match 'John' && 'age' >= 18`
 */
var filterQuery = function (constraints) {
    return constraints
        .reduce(function (acc, constraint) {
        var parts = [constraint.field];
        if (constraint.operator !== undefined && constraint.value !== undefined) {
            parts.push(constraint.operator);
            parts.push(constraint.value);
        }
        return __spreadArray(__spreadArray([], acc, true), [parts.join(' ')], false);
    }, [])
        .join(' && ');
};
exports.filterQuery = filterQuery;
/**
 * A function that builds an order query from a list of order constraints.
 * @param constraints - An array of order constraints.
 * @returns An order query string.
 * @example
 * const constraints = [
 *  {
 *    type: 'order',
 *    field: 'age',
 *    direction: 'asc',
 *  },
 *  {
 *    type: 'order',
 *    field: 'name',
 *    direction: 'desc',
 *  },
 * ]
 * const orderQueryString = orderQuery(constraints)
 * console.log(orderQueryString)
 * => order(age asc) | order(name desc)
 */
var orderQuery = function (constraints) {
    return constraints
        .reduce(function (acc, item) { return __spreadArray(__spreadArray([], acc, true), ["order(".concat(item.field, " ").concat(item.direction, ")")], false); }, [])
        .join(' | ');
};
exports.orderQuery = orderQuery;
/**
 * A function that builds a slice query from a slice constraint.
 * @param constraint - A slice constraint.
 * @returns A slice query string.
 * @example
 * const constraint = {
 *  type: 'slice',
 *  startIndex: 0,
 *  endIndex: 10,
 *  inclusive: false,
 * }
 * const sliceQueryString = sliceQuery(constraint)
 * console.log(sliceQueryString)
 * => [0...10]
 */
var sliceQuery = function (constraint) {
    var _a;
    var parts = ["[".concat(constraint.startIndex)];
    if (constraint.endIndex !== undefined) {
        var inclusive = (_a = constraint.inclusive) !== null && _a !== void 0 ? _a : constraint.startIndex === constraint.endIndex;
        parts.push(inclusive ? '..' : '...');
        parts.push(constraint.endIndex.toString());
    }
    parts.push(']');
    return parts.join('');
};
exports.sliceQuery = sliceQuery;
/**
 * A function that builds a query from a query object.
 * @param query - A query object. (Optional).
 * @returns A query string.
 * @example
 * const query = {
 *  constraints: [
 *   {
 *     type: 'filter',
 *     field: 'name',
 *     operator: 'match',
 *     value: 'John',
 *   },
 *   {
 *     type: 'order',
 *     field: 'age',
 *     direction: 'asc',
 *    },
 *    {
 *     type: 'slice',
 *     startIndex: 0,
 *     endIndex: 10,
 *     inclusive: false,
 *    },
 *  ],
 *  ordering: 'selection',
 * }
 * const queryString = buildQuery(query)
 * console.log(queryString)
 * => *[name match 'John'] | order(age asc) [0...10]
 */
var buildQuery = function (query) {
    var constraints = (query === null || query === void 0 ? void 0 : query.constraints) || [];
    var filterConstraints = findConstraints(constraints, 'filter');
    var orderConstraints = findConstraints(constraints, 'order');
    var sliceConstraint = findConstraints(constraints, 'slice')[0];
    var parts = [];
    if (filterConstraints.length > 0) {
        parts.push("*[".concat(filterQuery(filterConstraints), "]"));
    }
    else {
        parts.push("*[]");
    }
    if ((query === null || query === void 0 ? void 0 : query.ordering) === 'selection') {
        if (sliceConstraint) {
            parts.push(sliceQuery(sliceConstraint));
        }
        if (orderConstraints.length > 0) {
            parts.push("| ".concat(orderQuery(orderConstraints)));
        }
    }
    else {
        if (orderConstraints.length > 0) {
            parts.push("| ".concat(orderQuery(orderConstraints)));
        }
        if (sliceConstraint) {
            parts.push(sliceQuery(sliceConstraint));
        }
    }
    return parts.join(' ');
};
exports.buildQuery = buildQuery;
//# sourceMappingURL=query-builder.js.map